<div *ngIf="serviceLocation" class="moving" [ngClass]="{'sub-layer-active': store.state.common.determinantSection.topLayer === 'edit'}">
  <layer-header
    (closeLayer)="closeLayer()"
    [listIcons]="false"
    [title]="
      showDeterminantBuilder
        ? 'Collection Place - Determinant'
        : serviceLocation.id
        ? 'Edit Collection Place'
        : 'Add Collection Place'
    "
  >
    <ng-content></ng-content>
  </layer-header>
  <determinant-new
    *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
    class="row layer sub-layer px-3 pt-1"
    [serviceId]="serviceId"
    [determinant]="store.state.common.determinantSection.determinant"
    (formSubmit)="closeDetLayer()"
    (editCancel)="closeDetLayer()"
  ></determinant-new>
  <div
    class="row {{
      store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''
    }}"
  >
    <div class="col-12">
      <form name="itemForm" role="form">
        <div class="row mb-4 {{ showDeterminantBuilder ? '' : 'hidden' }}">
          <div class="col-12 mb-4">
            <primary-text-button (click)="submit()" [disabled]="isLoading">
              {{ 'Save' | translate }}
            </primary-text-button>
            <cancelary-text-button
              (click)="closeLayer()"
              [noRightMargin]="true"
            >
              {{ 'Cancel' | translate }}
            </cancelary-text-button>
          </div>
        </div>
        <div class="row mb-lg-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-md-12 col-lg-6">
            <label class="input-label field-required">{{
              'Name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="name"
              #name="ngModel"
              [(ngModel)]="serviceLocation.name"
              [rangeLength]="[2, 256]"
              required
            />
            <p
              class="validation-error"
              *ngIf="name.errors?.required && (name?.dirty && name?.touched)"
            >
              {{ 'form.validate.required' | translate }}
            </p>
            <p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 256!
            </p>
          </div>
        </div>
        <div class="row mb-lg-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-md-12 col-lg-6">
            <label class="input-label">{{ 'Address' | translate }}</label>
            <input
              class="form-control"
              type="text"
              name="address"
              [(ngModel)]="serviceLocation.address"
              #address="ngModel"
            />
          </div>
          <div class="col-md-12 col-lg-6">
            <label class="input-label">{{ 'City' | translate }}</label>
            <input
              class="form-control"
              type="text"
              name="city"
              [(ngModel)]="serviceLocation.city"
              #city="ngModel"
            />
          </div>
        </div>
        <div class="row mb-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-md-12 col-lg-6">
            <label class="input-label">{{ 'Phone' | translate }}</label>
            <input
              class="form-control"
              type="tel"
              name="phone"
              [(ngModel)]="serviceLocation.phone"
              #phone="ngModel"
            />
          </div>
          <div class="col-md-12 col-lg-6">
            <label class="input-label">{{ 'Email' | translate }}</label>
            <input
              class="form-control"
              type="email"
              name="email"
              [(ngModel)]="serviceLocation.email"
              #email="ngModel"
            />
          </div>
        </div>
        <div
          class="row no-gutters mb-0 {{
            showDeterminantBuilder ? '' : 'hidden'
          }}"
          *ngIf="registrationServiceLocation && registrationServiceLocation.id"
        >
          <div class="col-6 list-determinants">
            <determinant-list [groupsLength]="{value: registrationServiceLocation.jsonDeterminants}"  [prefix]="'sle'"
                              [determinantMapById]="determinantMapById" [addDeterminantTo]="appendDeterminant"></determinant-list>
          </div>
          <div class="col-6 px-3 query-builder">
            <query-builder *ngIf="determinantMapById != null" [determinantMapById]="determinantMapById"
                           [prefix]="'sle'"
              [jsonString]="registrationServiceLocation.jsonDeterminants"
              (onChange)="
                registrationServiceLocation.jsonDeterminants = $event.jsonString
              "
            ></query-builder>
          </div>
        </div>
        <div class="row my-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-12 mb-4">
            <primary-text-button
              (onClick)="submit()"
              [disabled]="isLoading || (name && name.invalid)"
            >
              {{ 'Save' | translate }}
            </primary-text-button>
            <cancelary-text-button
              (click)="closeLayer()"
              [noRightMargin]="true"
            >
              {{ 'Cancel' | translate }}
            </cancelary-text-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
